import { render, staticRenderFns } from "./ScreenAnchorCanvas.vue?vue&type=template&id=62eef26e&scoped=true&"
import script from "./ScreenAnchorCanvas.vue?vue&type=script&lang=js&"
export * from "./ScreenAnchorCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAnchorCanvas.vue?vue&type=style&index=0&id=62eef26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eef26e",
  null
  
)

export default component.exports